export default __webpack_public_path__ + "images/icon_checker_green_d4493950a780b949ba652248beb8b8c3.png";